import { ResponseError } from '@marketplace-web/core-api/api-client-util'
import { LiveChatAvailabilityResp } from 'types/api/response/live-chat-availability-resp'

import { api } from './api'

export const getLiveChatAvailability = (
  transactionId: number,
): Promise<LiveChatAvailabilityResp | ResponseError> =>
  api.get<LiveChatAvailabilityResp, ResponseError>(
    `/help_center/live_chat_status?transaction_id=${transactionId}`,
  )
